export default "__VITE_ASSET__96c39b9d__"